<div class="dialog-content-wrapper">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-auto justify-between items-center">
      <span class="title dialog-title">{{ title }}</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(dialogResult)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-4 pb-0 m-0" fusePerfectScrollbar>
    <div class="flex flex-col">
      <div class="mb-4" *ngIf="message">{{ message }}</div>
      <form #form="ngForm" [formGroup]="formGroup">
        <mat-form-field appearance="outline" class="w-full dense-input">
          <input
            type="number"
            required
            i18n-placeholder
            matInput
            formControlName="value"
            cdkFocusInitial
            [placeholder]="placeholder" />
        </mat-form-field>
      </form>
    </div>
  </div>

  <div mat-dialog-actions class="m-0 p-4 flex justify-end items-center">
    <button
      i18n
      mat-raised-button
      type="button"
      class="mat-accent mr-4"
      [disabled]="disableOnInvalid && !formGroup.valid"
      (click)="closeDialog()"
      >ОК</button
    >
    <button i18n mat-button (click)="dialogRef.close(dialogResult)">ОТМЕНА</button>
  </div>
</div>
